import http from "../http-common";

class BrandsDataService {
  getAll(data) {
    return http.get("/brands", data);
  }

  get(id) {
    return http.get(`/brands/${id}`);
  }

  create(data) {
    return http.post("/brands", data);
  }

  update(id, data) {
    return http.put(`/brands/${id}`, data);
  }

  delete(id) {
    return http.delete(`/brands/${id}`);
  }

  deleteAll() {
    return http.delete(`/brands`);
  }

  findByTitle(category) {
    return http.get(`/brands?category=${category}`);
  }
}

export default new BrandsDataService();